<section class="new-arrivals-section py-5 bg-light">
  <div class="container">
    <div class="section-title text-center mb-5">
      <div class="sparkles-icon mb-3">
        <img src="assets/img/sparkles.svg"
             alt="Sparkles"
             class="img-fluid"
             width="40" />
      </div>
      <p class="text-muted mb-2">
        {{ "translations.categories" | translate }}
      </p>
      <h4 class="fw-bold">
        {{ "translations.categoriesTXT" | translate }}
      </h4>
    </div>

    <div class="row g-4">
      <div class="col-lg-4 col-md-6" *ngFor="let product of products">
        <div class="card h-100 border-0 shadow-sm hover-elevation">
          <a class="position-relative" href="javascript:void(0);">
            <img [src]="
                product.photoPath
                  ? apiURL + product.photoPath
                  : 'assets/img/placeholder.png'
              "
                 [alt]="product.name"
                 class="card-img-top"
                 style="object-fit: cover; height: 300px"
                [routerLink]="['/products', { CID: product.gnCategoryID}]" />

          </a>

          <div class="card-body text-center">
            <h3 class="h5 card-title mb-3">
              {{ currentLang === "ar" ? product.nameAr : product.name }}
            </h3>
            
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
